var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSberPayBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 48 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#sber-pay-badge_svg__a)",
  d: "M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12H12C5.373 24 0 18.628 0 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12H12C5.373 24 0 18.628 0 12"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.94 13.3v2.74h-1.57V7.25h2.93c2.78 0 3.96.99 3.96 2.98 0 2.05-1.38 3.08-3.96 3.08zm0-4.61v3.16h1.48c1.46 0 2.21-.48 2.21-1.67 0-1.08-.65-1.49-2.18-1.49zm6.14 1.51c.41-.31 1.17-.56 2.25-.56 1.83 0 2.74.63 2.74 2.26v4.14h-1.38v-1.13c-.3.73-1.07 1.23-2.07 1.23-1.27 0-2.02-.71-2.02-1.95 0-1.43 1.04-1.83 2.59-1.83h1.42v-.28c0-.89-.43-1.17-1.27-1.17-1.15 0-1.82.45-2.25 1.12zm3.52 3.62v-.51h-1.25c-.87 0-1.28.16-1.28.73 0 .48.35.78 1 .78.99 0 1.46-.56 1.52-1m2.2-4.06h1.64l1.72 4.31 1.41-4.31h1.56l-2.51 6.95c-.55 1.51-1.12 1.85-1.95 1.85-.39 0-.82-.11-1-.28v-1.37c.2.2.47.31.75.32.45 0 .79-.3 1.03-1.15zm-26.35.45v1.93l2.56 1.6 6.12-4.5a6.7 6.7 0 0 0-.81-1.33L12 11.81z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.163 11.857v.14a5.172 5.172 0 0 1-7.278 4.73 5.17 5.17 0 1 1 5.025-8.992l1.311-.962a6.717 6.717 0 0 0-10.285 8.123 6.718 6.718 0 0 0 12.673-4.1z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sber-pay-badge_svg__a",
  x1: 25.875,
  x2: 53.318,
  y1: 41.611,
  y2: 10.474,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#c7e701"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.242,
  stopColor: "#0ada01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.439,
  stopColor: "#21de58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.632,
  stopColor: "#3ee3a9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.808,
  stopColor: "#37dabe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#15cae0"
})))));
export default SvgSberPayBadge;